module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid6_800x648.68ca418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid6_800x648.jpg
// module id = 8HV2
// module chunks = 0